import { OpenPluginType, PluginEnum } from '@meitu/saas-editor-core/es/version-types';
import { events, MORE_COLLAPSE_EVENT } from '@/events-bus';
import { editor } from '@/instance';
import { useStoreActions } from '@/store';

/** 进入ai生图的入口来源  */
export const AI_GENERATE_IMAGE_tracerEntrances = new Set();
export const AI_GENERATE_IMAGE_currentEntranceRef: { value: string | null } = { value: null };
export const AI_GENERATE_IMAGE_enter = (entrance: string) => {
    AI_GENERATE_IMAGE_tracerEntrances.add(entrance);
    AI_GENERATE_IMAGE_currentEntranceRef.value = entrance;
};

const useOpenPlugins = () => {
    const setIsAiExpendImage = useStoreActions((actions) => actions.pluginModel.setIsAiExpendImage);
    const setIsAiModifyImage = useStoreActions((actions) => actions.pluginModel.setIsAiModifyImage);
    const setIsAiGenerateImage = useStoreActions((actions) => actions.pluginModel.setIsAiGenerateImage);
    const setUrlOfAiGenerateImage = useStoreActions((actions) => actions.pluginModel.setExtDataOfAiGenerateImage);
    const setIsShowCollapse = useStoreActions((actions) => actions.editorModel.setIsShowCollapse);

    return {
        openPlugin: ({ func, entrance, hasTrackFunc, extData }: OpenPluginType) => {
            if (func === PluginEnum.AI_EXPEND_IMAGE) {
                setIsAiExpendImage(true);
                editor.tip.showMask({
                    background: true,
                });
            } else if (func === PluginEnum.AI_MODIFY_IMAGE) {
                setIsAiModifyImage(true);
                editor.tip.showMask({
                    background: true,
                });
            } else if (func === PluginEnum.AI_GENERATE_IMAGE) {
                setIsAiGenerateImage(true);
                setUrlOfAiGenerateImage(extData ?? null);
                editor.tip.showMask({
                    background: true,
                });
            }
            setIsShowCollapse(true);
            events.emit(MORE_COLLAPSE_EVENT, { func, entrance });
            hasTrackFunc &&
                window._stat_track?.('hbsj_subfunction_click', {
                    first_func: 'home_tools',
                    second_func: func,
                });
        },
    };
};

export default useOpenPlugins;
